import React, { useEffect,useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import DatePicker from "react-datepicker";
import * as RestService from '../../services/eisRest';
import moment from 'moment';




  const AttendanceEventModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
    
    const [selectedRecord, setSelectedRecord] = useState();    
    const [attendanceDetailId  , setAttendanceDetailId] = useState();    
    
  //  const [attendanceDetail, setAttendanceDetail] = useState([]);
    const [midnight, setMidnight] = useState(0);
    
    const [attendanceEvent, setAttendanceEvent] = useState([]);
    const [projectList, setProjectList] = useState([]);
    const [attendanceCodeList, setAttendanceCodeList] = useState([]);
    const [start, setStart] =  useState(null);  
    const [stop, setStop] =  useState(null);  
    const [whatDid, setWhatDid] =  useState(null);  
    const [lock, setLock] =  useState(0);  
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const [disabledSaveButton, setDisabledSaveButton] = useState(false);

  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('attendance/getAttendanceEvent?id='+props.selectedRecord, null)
      .then((data) => {
           setAttendanceEvent(data);
           setStart(data.start);
           setStop(data.stop);
           setWhatDid(data.whatDid);
      })
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])


   

    useEffect(() => {      
      setAttendanceDetailId(props.attendanceDetailId);
      RestService.callAnyApi('attendance/getAttendanceDetail?id='+props.attendanceDetailId, null)
      .then((data) => {
          // setAttendanceDetail(data);
           setLock(data.attendance.lock ? data.attendance.lock : 0);
           setMidnight(data.dateD);
           
      })
      .catch((error) => {
        console.log(error);
      });
    }, [props.attendanceDetailId])
    
  

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('attendance/deleteAttendanceEvent?id='+props.selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      //  console.log("AttendanceEventDatatable state.recordId:"+id);       
    }

    useEffect(() => {
      
      RestService.callAnyApi('attendance/getAttendanceCodeList', null).then((data) => { 
        data.map((item) => {
          item.label = t('attendance.label.'+item.label);
        });
        setAttendanceCodeList(data);
      }).catch((error) => {});      
      RestService.callAnyApi('project/getProjectSelectList', null).then((data) => { setProjectList(data);}).catch((error) => {});      
    }, []);
    
    
    
   // const onAttendanceEventSave = (data) =>{
   //   setAttendanceEvent(data);
   //   props.parentCallback(isOpen);
  //    hideModal();
  //  }    
    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          //WrongTimeInterval
          toast.error(t('attendance.label.'+serverMessage));
        }
    }

    const save = (url,values) => {

         
      if(attendanceDetailId==null || attendanceDetailId===''){return;}


      setDisabledSaveButton(true) ;
      
      attendanceEvent.attendanceCodeId=values.attendanceCodeId;
      attendanceEvent.projectId=values.projectId;
      attendanceEvent.description=values.description;
      attendanceEvent.start=start;
      attendanceEvent.stop=stop;
      attendanceEvent.whatDid=whatDid || '';
      if(attendanceEvent.attendanceDetailId==null){
        attendanceEvent.attendanceDetailId=attendanceDetailId;
      }
    

      RestService.callAnyApi(url, attendanceEvent)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          setAttendanceEvent(data.responseObject);
                          setStart(data.responseObject.start);
                          setStop(data.responseObject.stop);
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                      setDisabledSaveButton(false) ;
                 
          })
          .catch((error) => {               
            showError(error,null);
            setDisabledSaveButton(false) ;
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
        attendanceCodeId: attendanceEvent.attendanceCodeId || "",
        projectId: attendanceEvent.projectId || "",
        description: attendanceEvent.description || ""
      
        
      },
      validationSchema: Yup.object({
        attendanceCodeId: Yup.string()     
          .required(t('general.message.required')),
        description: Yup.string()     
          .required(t('general.message.required'))
         
      }),
      onSubmit: (values) => {           
          save('attendance/saveAttendanceEvent',values);         
      }
    });

    
    const handleChangeWhatDid = (event) => {

      setWhatDid(event.target.value);
  
    }

    const setHours = (value,start) => {

      if(value!=null){
          let hours = value.getHours();
          let minutes = value.getMinutes();
          let miliseconds = moment(midnight).set({ hour: hours, minute: minutes, second : 0 , millisecond : 0 }).valueOf();
          if(start==='start'){
            setStart(miliseconds)
          }else{
            setStop(miliseconds)
          }
      }
    }

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"                   
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('attendance.label.event')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
                              <div className="row">            
                                    <div class="col-12">
                                        <div class="form-group">
                                          <label>{t('attendance.label.code')}</label>                               
                                          <CustomSelect
                                                className='input'
                                                onChange={value=>formik.setFieldValue('attendanceCodeId',value.value)}
                                                value={formik.values.attendanceCodeId}
                                                options={attendanceCodeList}     
                                          />                                
                                        </div>
                                        {formik.touched.attendanceCodeId && formik.errors.attendanceCodeId ? (
                                          <div style={{ color: 'red' }}>{formik.errors.attendanceCodeId}</div>
                                        ) : null} 
                                      </div>                   
                              </div>         

                              <div className="row">     

                                    <div class="col-12">
                                      <div class="form-group">
                                        <label>{t('attendance.label.project')}</label>                               
                                        <CustomSelect
                                              className='input'
                                              onChange={value=>formik.setFieldValue('projectId',value.value)}
                                              value={formik.values.projectId}
                                              options={projectList}     
                                        />                                
                                      </div>
                                      {formik.touched.projectId && formik.errors.projectId ? (
                                        <div style={{ color: 'red' }}>{formik.errors.projectId}</div>
                                      ) : null} 
                                    </div>    
                              </div>  

                              <div className="row">                 					

                              <div className="col-6 col-sm-6 col-lg-6">
                             
                             
                                <div className="form-group">                                                                                                                
                                        <label>{t('attendance.label.start')}</label>  
                                        <DatePicker
                                            className='form-control'                                       
                                            selected={start ? start : midnight}
                                            onChange={(value) => setHours(value,'start')}                                           
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            dateFormat="HH:mm"                                    
                                            locale="sk"                                                  
                                        />                                                   						
                                </div>
                              </div>       
                            </div>              
                            

                            <div className="row">                 					

                              <div className="col-6 col-sm-6 col-lg-6">

                                 
                                <div className="form-group">      
                                        <label>{t('attendance.label.stop')}</label>                                                                                                           
                                        <DatePicker
                                            className='form-control'                                       
                                            selected={stop ? stop : midnight}
                                            onChange={(value) => setHours(value,'stop')}                                           
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            dateFormat="HH:mm"                                    
                                            locale="sk"                                                  
                                        />                                                   						
                                </div>
                              </div>       
                            </div>      

                            <div className="row"> 
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label>{t('general.label.description')}</label>
                                      <input type="text" class="form-control" placeholder="" {...formik.getFieldProps('description')} />
                                    </div>
                                    {formik.touched.description && formik.errors.description ? (
                                      <div style={{ color: 'red' }}>{formik.errors.description}</div>
                                  ) : null} 
                                  </div>                
                            </div>      

                            <div className="row"> 
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label>{t('general.label.whatDid')}</label>                                      
                                      <textarea 
                                        class="form-control"
                                        rows="3"
                                        placeholder=""                                      
                                        onChange={handleChangeWhatDid}
                                        value={whatDid}
                                      ></textarea>
                                    </div>                                   
                                  </div>                
                            </div>      


                    </Modal.Body>
                    <Modal.Footer>                          
                          <Button style={selectedRecord && lock==0 ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>    
                          <Button style={lock==0 ? {} : { display: 'none' }} className="btn-primary" type="submit"   disabled={disabledSaveButton}>{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 
      </>
    );
  };

 export default AttendanceEventModal;